var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadInGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a",
    x1: "61.027%",
    x2: "26.5%",
    y1: "4.947%",
    y2: "71.916%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".657%",
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "26.01%",
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "51.22%",
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.04%",
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__b",
    x1: "107.622%",
    x2: "-130.536%",
    y1: "50.016%",
    y2: "50.016%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40.87%",
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "77.54%",
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__c",
    x1: "86.253%",
    x2: "-50.188%",
    y1: "30.897%",
    y2: "136.081%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__d",
    x1: "-18.77%",
    x2: "42.12%",
    y1: "-11.832%",
    y2: "35.081%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "6.85%",
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.62%",
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80.09%",
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00F076"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M130 40H5c-2.75 0-5-2.25-5-5V5c0-2.75 2.25-5 5-5h125c2.75 0 5 2.25 5 5v30c0 2.75-2.25 5-5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6A6A6",
    d: "M130 .8c2.32 0 4.2 1.88 4.2 4.2v30c0 2.32-1.88 4.2-4.2 4.2H5C2.68 39.2.8 37.32.8 35V5C.8 2.68 2.68.8 5 .8h125m0-.8H5C2.25 0 0 2.25 0 5v30c0 2.75 2.25 5 5 5h125c2.75 0 5-2.25 5-5V5c0-2.75-2.25-5-5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M68.14 21.75c-2.35 0-4.27 1.79-4.27 4.25 0 2.45 1.92 4.25 4.27 4.25 2.35 0 4.27-1.8 4.27-4.25 0-2.46-1.92-4.25-4.27-4.25zm0 6.83c-1.29 0-2.4-1.06-2.4-2.58 0-1.53 1.11-2.58 2.4-2.58 1.29 0 2.4 1.05 2.4 2.58 0 1.52-1.12 2.58-2.4 2.58zm-9.32-6.83c-2.35 0-4.27 1.79-4.27 4.25 0 2.45 1.92 4.25 4.27 4.25 2.35 0 4.27-1.8 4.27-4.25 0-2.46-1.92-4.25-4.27-4.25zm0 6.83c-1.29 0-2.4-1.06-2.4-2.58 0-1.53 1.11-2.58 2.4-2.58 1.29 0 2.4 1.05 2.4 2.58 0 1.52-1.11 2.58-2.4 2.58zm-11.08-5.52v1.8h4.32c-.13 1.01-.47 1.76-.98 2.27-.63.63-1.61 1.32-3.33 1.32-2.66 0-4.74-2.14-4.74-4.8 0-2.66 2.08-4.8 4.74-4.8 1.43 0 2.48.56 3.25 1.29l1.27-1.27c-1.08-1.03-2.51-1.82-4.53-1.82-3.64 0-6.7 2.96-6.7 6.61 0 3.64 3.06 6.61 6.7 6.61 1.97 0 3.45-.64 4.61-1.85 1.19-1.19 1.56-2.87 1.56-4.22 0-.42-.03-.81-.1-1.13h-6.07v-.01zm45.31 1.4c-.35-.95-1.43-2.71-3.64-2.71-2.19 0-4.01 1.72-4.01 4.25 0 2.38 1.8 4.25 4.22 4.25 1.95 0 3.08-1.19 3.54-1.88l-1.45-.97c-.48.71-1.14 1.18-2.09 1.18s-1.63-.44-2.06-1.29l5.69-2.35-.2-.48zm-5.8 1.42c-.05-1.64 1.27-2.48 2.22-2.48.74 0 1.37.37 1.58.9l-3.8 1.58zM82.63 30h1.87V17.5h-1.87V30zm-3.06-7.3h-.07c-.42-.5-1.22-.95-2.24-.95-2.13 0-4.08 1.87-4.08 4.27 0 2.38 1.95 4.24 4.08 4.24 1.01 0 1.82-.45 2.24-.97h.06v.61c0 1.63-.87 2.5-2.27 2.5-1.14 0-1.85-.82-2.14-1.51l-1.63.68c.47 1.13 1.71 2.51 3.77 2.51 2.19 0 4.04-1.29 4.04-4.43v-7.64h-1.77v.69h.01zm-2.15 5.88c-1.29 0-2.37-1.08-2.37-2.56 0-1.5 1.08-2.59 2.37-2.59 1.27 0 2.27 1.1 2.27 2.59.01 1.48-.99 2.56-2.27 2.56zm24.39-11.08h-4.47V30h1.87v-4.74h2.61c2.07 0 4.1-1.5 4.1-3.88s-2.05-3.88-4.11-3.88zm.04 6.02H99.2v-4.29h2.65c1.4 0 2.19 1.16 2.19 2.14 0 .98-.79 2.15-2.19 2.15zm11.54-1.79c-1.35 0-2.75.6-3.33 1.91l1.66.69c.35-.69 1.01-.92 1.7-.92.96 0 1.95.58 1.96 1.61v.13c-.34-.19-1.06-.48-1.95-.48-1.79 0-3.6.98-3.6 2.81 0 1.67 1.46 2.75 3.1 2.75 1.25 0 1.95-.56 2.38-1.22h.06v.97h1.8v-4.79c.01-2.22-1.65-3.46-3.78-3.46zm-.23 6.85c-.61 0-1.46-.31-1.46-1.06 0-.96 1.06-1.33 1.98-1.33.82 0 1.21.18 1.7.42-.14 1.15-1.14 1.97-2.22 1.97zM123.74 22l-2.14 5.42h-.06L119.32 22h-2.01l3.33 7.58-1.9 4.21h1.95L125.82 22h-2.08zm-16.8 8h1.87V17.5h-1.87V30z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    d: "M1.44.54c-.29.31-.46.79-.46 1.4v22.12c0 .62.17 1.1.46 1.4l.07.07L13.9 13.15v-.3L1.51.47l-.07.07z",
    transform: "translate(9 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__b)",
    d: "M18.03 17.28l-4.13-4.13v-.3l4.13-4.13.09.05 4.89 2.78c1.4.79 1.4 2.09 0 2.89l-4.89 2.78-.09.06z",
    transform: "translate(9 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__c)",
    d: "M18.12 17.22L13.9 13 1.44 25.46c.46.49 1.22.55 2.08.06l14.6-8.3",
    transform: "translate(9 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__d)",
    d: "M18.12 8.78L3.51.48C2.65-.01 1.89.05 1.43.54L13.9 13l4.22-4.22z",
    transform: "translate(9 7)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.03.13L3.51 8.38c-.81.46-1.54.43-2 .01l-.07.07.07.07c.47.42 1.19.45 2-.01L18.12.22l-.09-.09z",
    opacity: 0.2,
    transform: "translate(9 7) translate(0 17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.44 8.32c-.29-.31-.46-.79-.46-1.4v.15c0 .62.17 1.1.46 1.4l.07-.07-.07-.08z",
    opacity: 0.12,
    transform: "translate(9 7) translate(0 17)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.01 14.3l-4.99 2.83.09.09L23 14.44c.7-.4 1.05-.92 1.05-1.44-.05.47-.4.94-1.04 1.3z",
    opacity: 0.12,
    transform: "translate(9 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.51.62l19.5 11.08c.63.36.99.82 1.05 1.3 0-.52-.35-1.05-1.05-1.44L3.51.48C2.11-.31.97.35.97 1.95v.15C.97.49 2.12-.17 3.51.62z",
    opacity: 0.25,
    transform: "translate(9 7)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.22 8L.22 2 .99 2 .99 7.26 3.59 7.26 3.59 8zM4.06 8l2.26-6h.87l2.26 6H8.6l-.58-1.63H5.5L4.91 8h-.85zm1.7-2.35h1.99l-.98-2.71h-.03l-.98 2.71zM10.32 8V2h1.83c.92 0 1.66.28 2.21.83.55.56.83 1.28.83 2.17 0 .89-.28 1.61-.83 2.17-.54.55-1.28.83-2.2.83h-1.84zm.77-.74h1.06c.69 0 1.24-.2 1.65-.6.41-.4.61-.95.61-1.67 0-.71-.2-1.26-.61-1.66-.41-.4-.95-.6-1.65-.6h-1.06v4.53h0zM16.28 8V2h1.83c.92 0 1.66.28 2.21.83.55.56.83 1.28.83 2.17 0 .89-.28 1.61-.83 2.17-.54.55-1.28.83-2.2.83h-1.84zm.77-.74h1.06c.69 0 1.24-.2 1.65-.6.41-.4.61-.95.61-1.67 0-.71-.2-1.26-.61-1.66-.41-.4-.95-.6-1.65-.6h-1.06v4.53zM21.49 8l2.26-6h.87l2.26 6h-.85l-.58-1.63h-2.52L22.34 8h-.85zm1.7-2.35h1.99l-.98-2.71h-.03l-.98 2.71zM29.77 8L29.77 2 30.71 2 33.63 6.67 33.66 6.67 33.63 5.51 33.63 2 34.4 2 34.4 8 33.6 8 30.55 3.11 30.5 3.11 30.53 4.27 30.53 8zM39.27 2.74L36.54 2.74 36.54 4.64 39 4.64 39 5.36 36.54 5.36 36.54 7.26 39.27 7.26 39.27 8 35.77 8 35.77 2 39.27 2 39.27 2.74zM40.48 8V2h1.83c.92 0 1.66.28 2.21.83.55.56.83 1.28.83 2.17 0 .89-.28 1.61-.83 2.17-.55.55-1.29.83-2.21.83h-1.83zm.77-.74h1.06c.69 0 1.24-.2 1.65-.6.41-.4.61-.95.61-1.67 0-.71-.2-1.26-.61-1.66-.41-.4-.95-.6-1.65-.6h-1.06v4.53zM49.21 8h-.77V2h2.04c.51 0 .95.17 1.32.51.37.34.56.76.56 1.28 0 .51-.19.94-.56 1.28-.37.34-.81.51-1.32.51h-1.27V8h0zm0-3.17h1.29c.32 0 .58-.11.78-.33.2-.22.29-.46.29-.72 0-.26-.1-.5-.29-.72-.2-.22-.46-.33-.78-.33h-1.29v2.1zM52.25 8l2.14-5.67c-.21-.17-.31-.4-.31-.67 0-.25.08-.45.25-.62.17-.17.37-.25.62-.25.24 0 .45.09.62.26.17.17.26.38.26.62 0 .27-.1.49-.31.67l2.14 5.67h-.85l-.58-1.63h-2.52L53.1 8h-.85zm1.7-2.35h1.99l-.98-2.71h-.03l-.98 2.71zm1-3.65c.09 0 .17-.03.23-.1.07-.07.1-.15.1-.23 0-.09-.03-.17-.1-.23-.07-.07-.14-.1-.23-.1s-.17.03-.23.1c-.07.07-.1.14-.1.23s.03.17.09.23.13.1.21.1h.03z",
    transform: "translate(41 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadInGooglePlay);
export default __webpack_public_path__ + "static/media/downloadInGooglePlay.5bb9048fb1159aad42892af08173cc04.svg";
export { ForwardRef as ReactComponent };